export default [
  {
    path: '/Comp-introduc',
    name: 'CEOGreeting',
    component: () => import('Components/company/content/CEOGreeting'),
  },
  {
    path: '/Comp-introduc/Corp-ideology',
    name: 'corpIdeology',
    component: () => import('Components/company/content/CorpIdeology'),
  },
  {
    path: '/Comp-introduc/History',
    name: 'History',
    component: () => import('Components/company/content/History'),
  },
  {
    path: '/Comp-introduc/Organization-chart',
    name: 'Organization',
    component: () => import('Components/company/content/OrganizationChart'),
  },
  {
    path: '/Comp-introduc/FindWay',
    name: 'FindWay',
    component: () => import('Components/company/content/FindWay'),
  },
]
